import {
  defaultStaffModuleAccess,
  resolveStaffModuleAccess,
} from './staffModulePermissions';

export const REPOSITORIO_HABERES_VARIABLES_MODULE_ID = 'repositorio_haberes_variables';
export const HABERES_VARIABLES_REPO_SECTION_KEY = 'haberes_variables';

export function isRepositorioHaberesVariablesModuleId(moduleId) {
  return moduleId === REPOSITORIO_HABERES_VARIABLES_MODULE_ID;
}

function isCompanyGranted(companyPerms) {
  if (companyPerms === undefined) return true;
  const companyPerm = (companyPerms || []).find(
    (p) => p.moduleId === REPOSITORIO_HABERES_VARIABLES_MODULE_ID,
  );
  return companyPerm?.hasAccess === true;
}

export function resolveRepositorioHaberesVariablesAccess(
  userPerms,
  companyPerms,
  userCompanyPerms,
  roles,
) {
  if (!isCompanyGranted(companyPerms)) return false;
  return resolveStaffModuleAccess(
    REPOSITORIO_HABERES_VARIABLES_MODULE_ID,
    userPerms,
    companyPerms,
    userCompanyPerms,
    roles,
  );
}

export function defaultRepositorioHaberesVariablesAccess(roles) {
  return defaultStaffModuleAccess(roles);
}
